module.exports = {
  "country": "BG",
  "artist": "Kristian Kostov",
  "song": "Beautiful Mess",
  "year": "2017",
  "place": "2",
  "spotify": "5YCqzqb6yN6TsMOHb4FSVw"
};